@if (task() || createMode()) {
  <div
    [ngClass]="{ 'rounded-md border border-proffeo-border': createMode() }"
    class="relative flex w-full flex-col gap-3 bg-proffeo-surface"
  >
    <div
      (click)="startDescriptionEdit()"
      [class.cursor-text]="isDescriptionEditing()"
      [class.cursor-pointer]="!isDescriptionEditing()"
    >
      <proffeo-ui-tiptap-editor
        (valueChange)="onDescriptionEdited($event)"
        [value]="currentDescription()"
        [minHeight]="isMobile() ? '0px' : minHeight()"
        [readonly]="!isDescriptionEditing()"
        [showMenu]="isDescriptionEditing()"
        variant="inline"
        class="block h-auto min-h-0 w-full px-2"
      />
    </div>

    @if (contentChanged() && !createMode()) {
      <div class="sticky bottom-0 flex w-full bg-proffeo-surface-muted px-4 py-2 shadow">
        <!-- Mobile layout -->
        <div class="flex w-full items-center justify-between gap-2 lg:hidden">
          <button
            (click)="revertDesc()"
            class="flex cursor-pointer items-center justify-center rounded-md bg-proffeo-danger p-1 transition-all hover:scale-90"
          >
            <mat-icon
              fontIcon="close"
              class="icon-white"
            />
          </button>
          <p>
            {{ 'project-tasks.details.description.unsaved-changes' | translate }}
          </p>
          <button
            (click)="updateDescription()"
            class="flex cursor-pointer items-center justify-center rounded-md bg-proffeo-success p-1 transition-all hover:scale-90"
          >
            <mat-icon
              fontIcon="check"
              class="icon-white"
            />
          </button>
        </div>

        <!-- Desktop layout -->
        <div class="hidden w-full items-center justify-between gap-2 lg:flex">
          <p>
            {{ 'project-tasks.details.description.unsaved-changes' | translate }}
          </p>
          <div class="flex items-center justify-center gap-3">
            <button
              (click)="revertDesc()"
              class="flex cursor-pointer items-center justify-center rounded-md bg-proffeo-danger p-1 transition-all hover:scale-90"
            >
              <mat-icon
                fontIcon="close"
                class="icon-white"
              />
            </button>
            <button
              (click)="updateDescription()"
              class="flex cursor-pointer items-center justify-center rounded-md bg-proffeo-success p-1 transition-all hover:scale-90"
            >
              <mat-icon
                fontIcon="check"
                class="icon-white"
              />
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}
